<template>
	<div>
		<!-- sr-only live region for step-change announcements -->
		<div ref="bbLiveRegion" class="sr-only" aria-live="polite" aria-atomic="true"></div>
		<!-- header container -->
		<Header/>
		<div class="bb-container">
			<div v-if="!dataFailure" class="uk-grid-collapse" uk-grid>
				<!-- builder preview -->
				<BuilderPreview />
				<!-- builder nav -->
				<Navigation />
				<!-- this component handles all the views that need to load -->
				<choose-size-view v-if="routeLocation === 'choose-size'" ref="currentView" />
				<wood-finish-view v-if="routeLocation === 'wood-finish'" ref="currentView" />
				<additions-view v-if="routeLocation === 'additions'" ref="currentView" />
				<left-cabinet-view v-if="routeLocation === 'left_cabinet'" ref="currentView" />
				<right-cabinet-view v-if="routeLocation === 'right_cabinet'" ref="currentView" />
				<mattress-view v-if="routeLocation === 'mattress'" ref="currentView" />
				<summary-view v-if="routeLocation === 'summary'" ref="currentView" />
			</div>
			<div v-else>
				The Bed Builder feature is currently unavailable. Please contact us at (866) 343-4523 to review your options.
			</div>
		</div>
		<InfoModal />
	</div>
</template>

<script>

import Navigation from "./Layout/Navigation.vue";
import InfoModal from "./InfoModal.vue";
import Header from "./Layout/Header.vue";
import BuilderPreview from "./Layout/BuilderPreview.vue";

import ChooseSizeView from '../views/ChooseSize.vue';
import WoodFinishView from '../views/WoodFinish.vue';
import AdditionsView from '../views/Additions.vue';
import LeftCabinetView from '../views/LeftCabinet.vue';
import RightCabinetView from '../views/RightCabinet.vue';
import MattressView from '../views/Mattress.vue';
import SummaryView from '../views/Summary.vue';

import {EventBus} from "../main";

export default {
	name: "BedBuilder",

	props: {
    dataFailure:{
      type: Boolean,
      default: false
    }
  },
	components: {BuilderPreview, 
    Header, 
    InfoModal, 
    Navigation,
    ChooseSizeView,
    WoodFinishView,
    AdditionsView,
    LeftCabinetView,
    RightCabinetView,
    MattressView,
    SummaryView,
  },
	data() {
		return {
      routeLocation: "choose-size"
    }
	},
	mounted() {
    EventBus.$on('navigate', this.navigateTo);
	},
  beforeDestroy() {
    EventBus.$off('navigate', this.navigateTo);
  },
  methods: {
    navigateTo(route) {
      this.routeLocation = route;
      // Announce + move focus to the new view so keyboard & SR users have
      // context. Home-rolled view switch (no Vue Router) means App.vue's
      // $route watcher never fires; handle here instead.
      this.$nextTick(() => {
        // Small extra delay lets child components mount fully before we
        // query for their DOM.
        setTimeout(() => {
          const label = route.replace(/_/g, ' ').replace(/\b\w/g, function (l) { return l.toUpperCase(); });
          if (this.$refs.bbLiveRegion) {
            this.$refs.bbLiveRegion.textContent = 'Step: ' + label;
          }
          this.focusNewView();
        }, 50);
      });
    },
    focusNewView() {
      const viewEl = this.$refs.currentView && this.$refs.currentView.$el;
      if (!viewEl) return;
      // Try: first heading/label inside the new view, else first focusable.
      function isVisible(el) {
        const r = el.getBoundingClientRect();
        if (r.width === 0 && r.height === 0) return false;
        const cs = getComputedStyle(el);
        return cs.visibility !== 'hidden' && cs.display !== 'none';
      }
      let target = viewEl.querySelector('h1, h2, .label');
      if (target && !isVisible(target)) target = null;
      if (!target) {
        const focusable = Array.prototype.slice.call(viewEl.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(isVisible);
        target = focusable[0];
      }
      if (!target) target = viewEl;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus();
    }
  },
	watch: {}
}
</script>